const BeimaContractAddress = '0xAB524Fc6F9c00c2d2D755CD394d03b4BF7bfC75a';
const RinkebyUSDTContractAddress = '0xD9BA894E0097f8cC2BBc9D24D308b98e36dc6D02';

export { BeimaContractAddress, RinkebyUSDTContractAddress };
